/**
 * 小游戏预览弹框组件
 * @author honggexuan
 * @since 19/03/18
 */

import './game-dialog.less';

import React from 'react';

import LotteryBar from 'components/preview/lottery-choose';
import { getUrlWithHttpsProtocol } from '@fe/common/lib/url';
import PreviewBuybtn from 'components/preview/buy-btn';

const GAME_PROTO_URL =
  'http://bbs.rabbitpre.com/forum.php?mod=viewthread&tid=19449&extra=';

// 获取作品预览左边模版,包含预览iframe,翻页按钮,二维码
export function getPreviewLeft(opts) {
  const { tplData } = opts;
  return (
    <div className="s-preview-game-left">
      <iframe src={tplData.previewUrl} scrolling="no" />
    </div>
  );
}

// 获取作品预览右边HTML模版
export function getPreviewRight(opts) {
  const {
    state,
    tplData,
    userInfo,
    getBuyState,
    buyTemplate,
    buyLocalTemplate,
    lotteryId,
    getLotteryBuyList,
  } = opts;
  const { coupon, buyState, lotteryTemplate } = state;
  tplData.lotteryId = lotteryId;
  // 兔展小游戏协议对象
  const protocolObj = {
    url: GAME_PROTO_URL,
    text: '兔展小游戏用户协议',
  };

  const { flag } = buyState;

  return (
    <div className="s-preview-game-right">
      <div className="game-info">
        <div className="icon-container">
          <img src={getUrlWithHttpsProtocol(tplData.icon)} />
        </div>
        <div className="game-detail">
          <div className="title">{tplData.districtTitle || '--'}</div>
          <div className="text">{tplData.districtDes || '--'}</div>
        </div>
      </div>
      <div className="game-select">
        <p className="text">*请选择活动玩法</p>
        <div className="award-option">
          <LotteryBar
            data={tplData}
            lottery={lotteryTemplate}
            getBuyState={getBuyState}
            getLotteryBuyList={getLotteryBuyList}
          />
        </div>
      </div>

      <div style={{ visibility: flag !== '1' ? 'hidden' : 'initial' }}>
        <PreviewBuybtn
          data={tplData}
          coupon={coupon}
          userInfo={userInfo}
          buyState={buyState}
          getBuyState={getBuyState}
          buyTemplate={buyTemplate}
          buyLocalTemplate={buyLocalTemplate}
          newClassName="game-buy-btn"
          protocol={protocolObj}
          getLotteryBuyList={getLotteryBuyList}
        />
      </div>

      {flag !== '1' ? (
        <div className="lottery-info-box">
          <div className="lottery-tips-qrcode">
            <div className="lottery-tips-box">
              <span>
                游戏已下架，同款游戏玩法及更多丰富玩法试用体验，请扫码添加企业专属客服。
              </span>
            </div>
            <div className="lottery-qrcode-box"></div>
          </div>
          {/* <div className="lottery-info-tel">
            <div className="lottery-icon-tel" />
            <span>400-040-3488</span>
          </div> */}
          <div className="lottery-info-mail">
            <div className="lottery-icon-mail" />
            <span>rabbitpre@tuzhanai.com</span>
          </div>
        </div>
      ) : null}
    </div>
  );
}
